import { render, staticRenderFns } from "./terms-nav.vue?vue&type=template&id=6ebe2594&scoped=true&"
import script from "./terms-nav.vue?vue&type=script&lang=js&"
export * from "./terms-nav.vue?vue&type=script&lang=js&"
import style0 from "./terms-nav.vue?vue&type=style&index=0&id=6ebe2594&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebe2594",
  null
  
)

export default component.exports